module.exports = __webpack_public_path__ + "static/media/add test.cb728078.svg";